import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from './Link';
import Spinner from '../Navigation/Spinner';

import './Button.module.css';

const Button = ({
  type,
  arrow,
  children,
  color,
  loading,
  small,
  styles,
  url,
  to,
  openInNewWindow,
  className,
  ...rest
}) => {
  const styleName = classNames('button', arrow, color, {
    small,
    loading
  });

  const content = (
    <span styleName="content">
      {loading && (
        <span styleName="spinner">
          <Spinner size={2} color={color === 'dark' ? '#fff' : '#1082f0'} />
        </span>
      )}
      <span>{children || ''}</span>
    </span>
  );

  if (type === 'button') {
    return (
      <button
        type="button"
        className={className}
        styleName={styleName}
        style={styles}
        {...rest}
      >
        {content}
      </button>
    );
  }

  return (
    <Link
      to={loading ? null : to || url}
      openInNewWindow={openInNewWindow || arrow === 'new-tab'}
      className={className}
      styleName={styleName}
      style={styles}
      {...rest}
    >
      {content}
    </Link>
  );
};

Button.propTypes = {
  type: PropTypes.oneOf(['link', 'button']),
  url: PropTypes.string,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]),
  arrow: PropTypes.oneOf([
    'left',
    'right',
    'none',
    'right-caret',
    'left-caret',
    'new-tab'
  ]),
  color: PropTypes.oneOf([
    'dark',
    'light',
    'white',
    'light-blue',
    'reverse-blue',
    'borderless-blue',
    'white-blue-text',
    'inherit-color'
  ]),
  loading: PropTypes.bool,
  small: PropTypes.bool,
  children: PropTypes.node,
  styles: PropTypes.object
};

Button.defaultProps = {
  type: 'link',
  arrow: 'none',
  color: 'dark',
  loading: false,
  small: false
};

export default Button;
